import { useState, useCallback } from 'react';

import { confluenceLocalStorageInstance as localStorage } from '@confluence/storage-manager/entry-points/storageInstance.ts';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys.ts';

const getIsDismissed = () => {
	return (
		String(
			localStorage?.getItem(
				PERSISTED_KEYS_ON_SERVER.PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT,
			),
		) === 'true'
	);
};
// Migrator Admin Prompt Banner Dismissal State Hook
export const useMigratorPromptDismissalState = (): {
	isDismissed: boolean;
	onDismiss: () => void;
} => {
	const [isDismissed, setIsDismissed] = useState<boolean>(getIsDismissed);

	const onDismiss = useCallback((): void => {
		localStorage.setItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_ADMIN_ANNOUNCEMENT_BANNER_MIGRATOR_PROMPT,
			'true',
		);
		setIsDismissed(true);
	}, []);

	return { isDismissed, onDismiss };
};
